export default __webpack_public_path__ + "static/media/body-bkg-pattern.87b863ff.png";